import React from 'react'

import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined'
import DataUsageOutlinedIcon from '@mui/icons-material/DataUsageOutlined'
import HistoryOutlinedIcon from '@mui/icons-material/HistoryOutlined'
import SmartToyOutlinedIcon from '@mui/icons-material/SmartToyOutlined'
import ToggleOnOutlinedIcon from '@mui/icons-material/ToggleOnOutlined'
import WorkspacePremiumOutlinedIcon from '@mui/icons-material/WorkspacePremiumOutlined'
import { blue, deepPurple, grey, lime, pink, teal } from '@mui/material/colors'

export type DetailsPanelId = 'identity' | 'plan' | 'usage' | 'flags' | 'timeline' | 'ai'

export type DetailsPanelStyle = { title: string; icon: React.ReactNode; color: string }

// Hues at least 30 degrees apart; not green (Yes badges are `success`) nor orange/red (usage bars turn `warning`/`error`).
export const DETAILS_PANELS: Record<DetailsPanelId, DetailsPanelStyle> = {
  identity: { title: 'Identity', icon: <BadgeOutlinedIcon fontSize="small" />, color: blue[900] },
  plan: { title: 'Plan', icon: <WorkspacePremiumOutlinedIcon fontSize="small" />, color: teal[700] },
  usage: { title: 'Usage this month', icon: <DataUsageOutlinedIcon fontSize="small" />, color: pink[900] },
  flags: { title: 'Account flags', icon: <ToggleOnOutlinedIcon fontSize="small" />, color: lime[900] },
  timeline: { title: 'Timeline', icon: <HistoryOutlinedIcon fontSize="small" />, color: grey[600] },
  ai: { title: 'AI context', icon: <SmartToyOutlinedIcon fontSize="small" />, color: deepPurple[400] },
}
